import { apiClient } from "../../../lib/apiClient";
import type { ApiResponse } from "../../../types/apiResponse";
import type { ParamsSearchStatusBill, StatusBill } from "../types";

const fetchStatusBill = async ({ rfcRecipient, rfcSender, total, uuidBill }: ParamsSearchStatusBill): Promise<ApiResponse<StatusBill>> => {
  return apiClient<ApiResponse<StatusBill>>(`/v1/sat/consulta/estatus/${rfcSender}/${rfcRecipient}/${total}/${uuidBill}`, {
    method: 'GET'
  });
}

export default fetchStatusBill;